import { useWindowDimensions } from "@/components/hooks/use-window-dimension/";
import {
  Dialog,
  DialogContent,
  View,
  DialogHeader,
  DialogTitle,
  Button,
} from "@/components/ui";
import { IconButton } from "@/components/ui/icon-button";
import { Typography } from "@/components/shared/typography";
import { handleOpenLink } from "@/lib/platform";
import { onChatSales } from "@/lib/chat-sales";

export function ServiceLearnMoreDialog({
  open,
  handleClose,
  url,
}: {
  open: boolean;
  handleClose: () => void;
  url: string;
}) {
  return (
    <Dialog open={open} onOpenChange={handleClose}>
      <DialogContent className="w-[400px] max-w-full gap-2 rounded-lg p-4">
        <View>
          <DialogHeader className="flex flex-row justify-between gap-2">
            <View className="flex flex-row items-center gap-1">
              <DialogTitle>Need Help With This Service?</DialogTitle>
            </View>
            {useWindowDimensions().isDesktop && (
              <IconButton
                variant="ghost"
                color="foreground"
                size="md"
                iconName="x"
                onClick={handleClose}
              />
            )}
          </DialogHeader>
        </View>

        <Typography variant="body-sm" color="foreground-intermediate">
          Choose how you’d like to continue
        </Typography>
        <View className="mt-4 flex flex-col gap-2">
          <Button
            variant="primary"
            color="CTA"
            rounded="full"
            onClick={() => onChatSales(true)}
            children="Contact Us"
          />
          <Button
            variant="secondary"
            color="CTA2"
            rounded="full"
            onClick={() => handleOpenLink(url)}
            children="Learn More"
          />
        </View>
      </DialogContent>
    </Dialog>
  );
}
